export default "__VITE_ASSET__ycZpSxxw__"